export function checkIfElementIsVisibleOnScroll({
  element,
  elementInViewportCallback = () => {
    console.log("Element is in viewport");
  },
  elementNotInViewportCallback = () => {
    console.log("Element is not in viewport");
  },
}) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        elementInViewportCallback();
      } else {
        elementNotInViewportCallback();
      }
    });
  });
  observer.observe(element);
}

/** ANCHOR - Aplicação de template
 * [generateTemplateContent - copia um template de html para dentro de um outro elemento, fazendo os devidos ajustes]
 * @author Eduardo de Paula Xavier eduardo.xavier@irroba.com.br
 * @param  [String: id do Template que será copiado]
 * @param  [String: id do elemento o qual o template será inserido dentro]
 * @param  [obj: objeto contendo as palavras do template que representam variáveis, sendo que a chave do objeto e a palavra que será substituída pelo seu valor]
 * @return [void: o html do template será inserido dentro do elemento de id_to_paste]
 */
export function generateTemplateContent(template_id, id_to_paste, variables) {
  const template = document.getElementById(template_id);
  const htmlContent = template.cloneNode(true);
  const novoItemHTML = replaceString(htmlContent.innerHTML, variables);
  const resultHtml = parseToHtml(novoItemHTML);
  appendChildrenToElement(resultHtml, id_to_paste);
}

function appendChildrenToElement(element, id_to_paste) {
  const targetElement = document.getElementById(id_to_paste);
  Array.from(element.childNodes).forEach((child) => {
    targetElement.appendChild(child);
  });
}

/** ANCHOR -Transformação de string em HTML
 * [parseToHtml - transforma uma string de html em um elemento de html da DOM ]
 * @author Eduardo de Paula Xavier eduardo.xavier@irroba.com.br
 * @param  [String: string do html]
 * @return [um elemento DOM de html ]
 */
export function parseToHtml(element) {
  return new DOMParser().parseFromString(element, "text/html").body;
}

/** ANCHOR - Alteração de Palavras de uma frase
 * [replaceString - substitui variáveis de uma string por valores de acordo com um objeto de substituição]
 * @author Eduardo de Paula Xavier eduardo.xavier@irroba.com.br
 * @param  [String: string a ser substituída]
 * @param  [obj: objeto contendo as palavras a serem substituídas como chave, que serão alteradas por seus respectivos valores]
 * @return [String: retorna a string com os valores substituídos]
 */
export function replaceString(string, substituicoes) {
  let novaString = string;
  Object.keys(substituicoes).forEach(function (key) {
    const regex = new RegExp(`\\${key}|${key}`, "g");
    novaString = novaString.replace(regex, substituicoes[key]);
  });
  return novaString;
}